/**
 * @author Rahul Nainala
 * @description 
 */
import '../CSS/eLog.css';
import moment from 'moment';
import styles from '../CSS/style.less';
import { deleteFileUpload } from '../eLogCalls';
import { SelectComponent, KeyComponent } from '.';
import React, { useState, useEffect } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { MASTER } from '../../../../commons/api.js';
import localStorage from '../../../../utils/localStorage';
import StyledTable from '../../../../commons/styles/table.js';
import { Input, Upload, Button, DatePicker, message, InputNumber, TimePicker } from 'antd';

const TableViewInTable = (props) => {
  const [form, setForm] = useState(props.form || {});
  const [columns, setColumns] = useState(props.form && props.form.columns ? props.form.columns : []);
  const [modal, setModal] = useState(props.form && props.form.modal ? props.form.modal : []);
  const [data, setData] = useState(
    props.form && props.form.datasource
      ? props.form.datasource.map((dataSource, index) => ({ ...dataSource, key: index + 1 }))
      : []
  );
  const [loading, setLoading] = useState(false);
  // const [open, setOpen] = useState(false);
  // const [mainHeaderValue, setMainHeaderValue] = useState(props.mainHeaderValue ? props.mainHeaderValue : {});
  // const [subHeaderValue, setSubHeaderValue] = useState(props.subHeaderValue ? props.subHeaderValue : {});

  useEffect(() => {
    let columns = generateColumns(
      props.form && props.form.columns ? props.form.columns : [],
      props.mainHeaderValue ? props.mainHeaderValue : {},
      props.subHeaderValue ? props.subHeaderValue : {}
    );
    setForm(props.form);
    setColumns(columns);
    setModal(props.form && props.form.modal ? props.form.modal : []);
    setData(
      props.form && props.form.datasource
        ? props.form.datasource.map((dataSource, index) => {
          return {
            ...dataSource,
            key: index + 1
          };
        })
        : []
    );
  }, []);

  const generateColumns = (columns, mainHeaderValue, subHeaderValue) => {
    let { translationCache } = props;
    let finalColumns = [];

    if (columns && columns.length > 0) {
      finalColumns = columns.map((column) => {
        return {
          title:
            translationCache && translationCache[column.title]
              ? translationCache[column.title]
              : column.title,
          dataIndex: column.key || 0,
          key: column.key || 0,
          width: column.width,
          widget: column.widget,
          required: column.required,
          table: column.table || {},
          render: (text, record) => {
            return renderWidget(
              column,
              text,
              record,
              columns,
              mainHeaderValue,
              subHeaderValue
            );
          }
        };
      });
    }
    return finalColumns;
  };

  const deleteFile = async (file) => {
    if (file && file.response && file.response.name) {
      await deleteFileUpload(file.response.name);
      message.success('File Deleted');
    } else {
      message.error('Error deleting file');
    }
  };

  const onFileChange = (info, column, text, record) => {
    if (info.file.status === 'done') {
      let fieldValue = [];
      if (text && Array.isArray(text) && text !== undefined) {
        fieldValue = [...text, info.file.response];
      } else if (!text) {
        fieldValue = [info.file.response];
      }
      handleFieldChange(fieldValue, column.key, record.key, column);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    } else if (info.file.status === 'removed') {
      deleteFile(info.file);
      handleFieldChange(info.fileList, column.key, record.key, column);
    }
  };

  const renderWidget = (column, text, record, columns, mainHeaderValue, subHeaderValue) => {
    const token = localStorage.get('accessToken');
    let { translationCache } = props;
    let defaultFileList = text && Array.isArray(text) ? text : [];
    var Authorization = 'Bearer ' + token;
    const renderProps = {
      name: 'file',
      action: `${MASTER.FileUpload}`,
      headers: {
        Authorization: Authorization
      },
      defaultFileList
    };
    switch (column.widget) {
      case 'input':
        return (
          <Input
            autoFocus
            value={
              column
                ? translationCache && translationCache[text] && translationCache[text]
                  ? translationCache[text]
                  : text
                : text
            }
            style={{ fontWeight: 'bold' }}
            onChange={(e) => handleFieldChange(e.target.value, column.key, record.key, column)}
            maxLength={columns && columns.maxLength ? columns.maxLength : 100}
            onKeyPress={(e) => handleKeyPress(e.target.value, record.key)}
            placeholder={column.placeHolder || column.displayName}
            disabled={column.disable ? column.disable : false}
          />
        );
      case 'inputNumber':
        return column.widgetCondition &&
          column.widgetCondition === true &&
          record.widget !== undefined &&
          record.widget !== true ? (
          <InputNumber value="" disabled style={{ width: '90%', fontWeight: 'bold' }} />
        ) : (
          <InputNumber
            value={text}
            style={{ width: '90%', fontWeight: 'bold' }}
            min={column.min !== undefined ? column.min : 0}
            max={column.max !== undefined ? column.max : 1000000}
            // onChange={(e) => handleFieldChange(e, column.key, record.key)}
            onChange={(e) =>
              inputNumberChange(column.min, column.max, e, column.key, record.key, column)
            }
            onKeyPress={(e) => handleKeyPress(e.target.value, record.key)}
            placeholder={column.placeHolder || column.displayName}
          />
        );
      case 'textComponent':
        return (
          <KeyComponent
            data={data}
            column={column}
            record={record}
            text={text}
            datasource={mainHeaderValue ? mainHeaderValue : {}}
            subdatasource={subHeaderValue ? subHeaderValue : {}}
            handleDataChange={handleDataChange}
          // handleKeyPress={handleKeyPress}
          />
        );
      case 'select':
        return (
          <SelectComponent
            data={data}
            column={column}
            record={record}
            text={text}
            datasource={mainHeaderValue ? mainHeaderValue : {}}
            subdatasource={subHeaderValue ? subHeaderValue : {}}
            handleFieldChange={handleFieldChange}
            handleKeyPress={handleKeyPress}
          />
        );
      case 'upload':
        return (
          <Upload
            {...renderProps}
            onChange={(info) => onFileChange(info, column, text, record)}
          >
            <Button>
              <UploadOutlined /> Upload
            </Button>
          </Upload>
        );
      case 'timePicker':
        return (
          <TimePicker
            format="HH:mm:ss"
            value={text && text !== 'Invalid date' ? moment(text, 'HH:mm:ss') : undefined}
            style={{ width: 500 }}
            disabled={columns.disable ? columns.disable : false}
            onChange={(e) => handleFieldChange(e, column.key, record.key, column)}
          />
        );
      case 'date-picker':
        return (
          <DatePicker
            value={text ? moment(text, 'YYYY-MM-DD') : undefined}
            format={columns.showTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'}
            allowClear={false}
            showNow={false}
            showTime={columns.showTime ? columns.showTime : false}
            disabled={columns.disable ? columns.disable : false}
            onChange={(e) => handleFieldChange(e, column.key, record.key)}
            style={{ width: 300 }}
          />
        );
      default:
        return text;
    }
  };

  const saveRow = (e, key, record) => {
    e.persist();
    setLoading(true);
    const target = getRowByKey(key) || {};
    let checkReqField = false;
    columns &&
      Array.isArray(columns) &&
      columns.map((columnsObject) => {
        if (
          columnsObject['required'] &&
          (columnsObject['required'] === 'true' || columnsObject['required'] === true)
        ) {
          if (
            target[columnsObject.key] ||
            (target[columnsObject.key] === 0 &&
              (target[columnsObject.key] !== '' || (record && record.widget === false)))
          ) {
            return {};
          } else {
            e.target.focus();
            checkReqField = true;
          }
        }
        return {};
      });
    if (checkReqField) {
      message.warn('Please fill in the complete information');
    } else {
      saveToggleEditable(e, key);
      setLoading(false);
    }
  };

  // const editRow = (key) => { toggleEditable(key); };

  // const cancel = (e, key) => {
  //   clickedCancel = true;
  //   e.preventDefault();
  //   const newData = data.map((item) => ({ ...item }));
  //   const target = getRowByKey(key, newData);
  //   if (cacheOriginData !== undefined) {
  //     if (cacheOriginData[key]) {
  //       Object.assign(target, cacheOriginData[key]);
  //       delete cacheOriginData[key];
  //     }
  //   }
  //   target.editable = false;
  //   setData(newData);
  //   clickedCancel = false;
  // };

  const getRowByKey = (key, newData) => {
    return (newData || data).filter((item) => item.key === key)[0];
  };

  const saveToggleEditable = (e, key) => {
    e.preventDefault();
    const newData = data.map((item) => ({ ...item }));
    const target = getRowByKey(key, newData);
    if (target) {
      // if (!target.editable && cacheOriginData) {
      //   cacheOriginData[key] = { ...target };
      // }
      target.editable = !target.editable;
      setData(newData);
      props.saveTableViewData(newData);
      //  Save to Backend
    }
  };

  // const toggleEditable = (key) => {
  //   const newData = data.map((item) => ({ ...item }));
  //   const target = getRowByKey(key, newData);
  //   if (target) {
  //     target.editable = !target.editable;
  //     setData(newData);
  //     props.saveTableViewData(newData);
  //   }
  // };

  // const remove = (key) => {
  //   if (key.isNew) {
  //     const newData = data.filter((item) => item.key !== key.key);
  //     setData(newData);
  //     //Delete BAckend Call
  //   } else {
  //     message.error('Cant delete this record..');
  //   }
  // };

  const handleKeyPress = (e, key) => {
    if (e.key === 'Enter') {
      saveRow(e, key);
    }
  };

  const inputNumberChange = (minValue, maxValue, value, key, record, column) => {
    if (
      value >= minValue &&
      value <= maxValue &&
      minValue !== undefined &&
      maxValue !== undefined
    ) {
      handleFieldChange(value, key, record, column);
    } else if (minValue === undefined && maxValue === undefined) {
      handleFieldChange(value, key, record, column);
    } else {
      handleFieldChange('', key, record, column);
      message.error(`The input range must between ${minValue} and ${maxValue}`);
    }
  };

  const handleFieldChange = async (fieldValue, fieldName, keyValue, column) => {
    const newData = data.map((item) => ({ ...item }));
    const target = getRowByKey(keyValue, newData);
    if (target) {
      if (fieldName === 'StartTime' || (column && column.widget === 'timePicker')) {
        target[fieldName] = moment(fieldValue).format('HH:mm:ss');
      } else if (fieldName === 'Date') {
        target[fieldName] = moment(fieldValue).format('YYYY-MM-DD');
      } else {
        target[fieldName] = fieldValue;
      }

      let newObj = [];
      if (column && column.autopopulate && column.autoPopulateCondition) {
        newObj = [];
        column.autoPopulateCondition.map((dataObject) => {
          if (newData[keyValue - 1][dataObject]) {
            newObj.push(newData[keyValue - 1][dataObject]);
          }
          return {};
        });
        target['Max'] = Math.max.apply(
          Math,
          newObj.map(function (o) {
            return o;
          })
        );
      }
      setData(newData);
      props.saveTableViewData(newData, column, fieldValue);
    }
  };

  const handleDataChange = (fieldValue, fieldName) => {
    const newData = data.map((item) => ({ ...item }));
    if (columns) {
      return {};
    }
    if (newData) {
      newData.map((item, key) => {
        newData[key][fieldName] = fieldValue;
        return {};
      });
      setData(newData);
    }
    props.saveTableViewData(newData);
  };

  const addRow = () => {
    let dataLength = data.length + 1;
    let newdata = {
      key: dataLength,
      editable: true
    };
    modal &&
      Array.isArray(modal) &&
      modal.map((columnData) => {
        newdata[columnData.key] = '';
        return {};
      });

    data.push(newdata);
    setData(data);
    props.saveTableViewData(data);
  };

  let { translationCache } = props;
  return (
    <div 
    //className="tableView" 
    style={{ marginTop: '10px' }}>
      <div>
        <h2 style={{ fontWeight: 'bold' }}>
          {translationCache && translationCache[form.heading] && translationCache[form.heading]
            ? translationCache[form.heading]
            : form.heading}
        </h2>
        <StyledTable size="small"
          loading={loading}
          columns={columns}
          dataSource={data}
          pagination={false}
          style={{ marginTop: '10px', border: '1px solid  red !important' }}
          rowClassName={(record) => (record.editable ? styles.editable : '')}
        />
        {form && form.showAddButton ? (
          <Button type="primary" style={{ marginTop: '10px' }} onClick={addRow}>
            {translationCache && translationCache['Add Row'] && translationCache['Add Row']
              ? translationCache['Add Row']
              : 'Add Row'}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default TableViewInTable;
